import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { TransformCta } from '../TransformCta';
export function Guarantee() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-185" data-mp="20m4obp53y8tf">
      <div className="mx-auto max-w-2xl" data-id="element-186" data-mp="24myekp60vzph">
        <div className="rounded-3xl border border-gold-200 bg-white p-5 shadow-card sm:p-7" data-id="element-187" data-mp="24lx4amwtzh8t">
          <div className="flex flex-col items-center text-center" data-id="element-188" data-mp="29fhuhss6n6xg">
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gold-100" data-id="element-189" data-mp="2edt4q4me3jg7">
              <ShieldCheckIcon className="h-7 w-7 text-gold-600" aria-hidden="true" data-id="element-190" data-mp="2jbba5l177gjg" />
            </span>
            <h2 className="mt-4 font-display text-[22px] font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-191" data-mp="2oc8ti0xy2gmj">
              Tu inversión está completamente protegida
            </h2>
          </div>

          <div className="mt-5 space-y-3 text-[14.5px] leading-relaxed text-navy-600 sm:text-base" data-id="element-192" data-mp="ty7wzmpva5pm">
            <p data-id="element-193" data-mp="xzt2uo3zhjqb">
              Sabemos que un sistema como este debe demostrar su valor cuando lo aplicas en casos
              reales. Por eso puedes revisarlo con calma durante los próximos 7 días.
            </p>
            <p data-id="element-194" data-mp="3nt5aogbipv7f">
              Si consideras que el Sistema de Diagnóstico Facial no te ayuda a organizar mejor tu
              proceso diagnóstico o no cumple con lo que promete, solo tienes que escribirnos.
            </p>
            <p className="font-semibold text-navy-900" data-id="element-195" data-mp="3duft6onjacrp">
              Te devolveremos el 100% de tu dinero, sin preguntas y sin complicaciones. Así de
              simple.
            </p>
          </div>
        </div>

        <TransformCta headline="Pruébalo en tus propios casos con riesgo cero durante 7 días." label="Quiero probarlo sin riesgo" location="garantia" data-id="element-196" data-mp="5gqmt9hp2wjd" />
      </div>
    </section>;
}